module.exports = __webpack_public_path__ + "img/ceipes-italy.4c4078ab.png";